import { StyleProp, ViewStyle } from 'react-native';
import Animated from 'react-native-reanimated';
import styled from 'styled-components/native';

interface Props {
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;

  hidden?: boolean;
}

export const FloatingActions = ({ hidden, ...props }: Props) => {
  return (
    <Row pointerEvents="box-none" style={props.style}>
      {props.children}
    </Row>
  );
};

const Row = styled(Animated.View)`
  position: absolute;
  flex-direction: row;
  justify-content: center;
  left: 0;
  bottom: 30px;
  width: 100%;
  gap: 100px;
`;
